import { render } from "./MakeFinalAllPayment.vue?vue&type=template&id=daa6d7a8"
import script from "./MakeFinalAllPayment.vue?vue&type=script&lang=js"
export * from "./MakeFinalAllPayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__